import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import FieldHeader from "./FieldHeader";

const SubmitComponent = ({ loading }) => {
	return (
		<Box sx={{ marginBottom: "3rem" }}>
			<FieldHeader header="Submit Form" subHeader="Submit form for approval" />
			<Box>
				<Box
					sx={{
						backgroundColor: "#fff",
						padding: "1.5rem",
						color: "#718096",
					}}
				>
					<Typography variant="body2">
						This action will submit the above details for approval.
					</Typography>
					<Typography variant="body2" sx={{ mb: "1.5rem" }}>
						By submitting, you agree that you have filled the correct details.
					</Typography>
					<Button
						variant="contained"
						type="submit"
						color="success"
						disabled={loading}
					>
						{loading ? (
							<CircularProgress color="primary" size="1.5rem" />
						) : (
							"submit information"
						)}
					</Button>
				</Box>
			</Box>
		</Box>
	);
};

export default SubmitComponent;
